// extracted by mini-css-extract-plugin
module.exports = {"scenarioTableRoot":"uIBZfVcL","tableRoot":"srCNVlbh","insightsWrapper":"xUZaxgZ0","tickerCell":"ReWSqdOK","wrapperEmptyAssetsState":"f0WkYG5U"};